
import {stringToDigits} from './formatting';


export function nameValidation(testName) {
	if(testName === null) {
		return "Enter valid name";
	}
	let testLength = testName.trim().length;
	if(testLength <= 0) {
		return "Enter valid name";
	}
	if(testLength > 100) {
		return "100 characters maximum";
	}
	return null;
}

export function emailValidation(testEmail) {
	if(testEmail === null) {
		return "Enter valid email address";
	}
	let testLength = testEmail.trim().length;
	if(testLength <= 0) {
		return "Enter email address";
	}
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!re.test(testEmail)) {
  	return "Enter valid email";
  }
	return null;
}

export function phoneValidation(testPhone) {
	if(!testPhone) {
		return "Enter valid phone number";
	}
	let numberString = stringToDigits(testPhone);
	if(numberString.length != 10) {
		return "Phone numbers must have 10 digits";
	}
	return null;
}

export function passwordValidation(testPassword) {
	if(testPassword === null) {
		return "Enter valid password";
	}
	if(testPassword != testPassword.trim()) {
		return "Cannot begin or end with a space";
	}
	let testLength = testPassword.trim().length;
	if(testLength < 8) {
		return "Must be at least 8 characters";
	}
	return null;
}

export function ccNumberValidation(testNumber) {
	if(testNumber === null) {
		return "Enter a valid credit card number";
	}
	let isNum = /^\d+$/.test(testNumber);
	let validLenth = testNumber.length >= 14 && testNumber.length <= 16;
	if(!isNum || !validLenth) {
		return "Enter a valid credit card number";
	}
	return null;
}

export function ccCvcValidation(testCVC) {
	if(testCVC === null) {
		return "Enter a valid CVC";
	}
	let isNum = /^\d+$/.test(testCVC);
	let validLenth = (testCVC.length == 3 || testCVC.length == 4);
	if(!isNum || !validLenth) {
		return "Enter a valid CVC";
	}
	return null;
}

export function idNumberValidation(testIdNumber) {
	if(testIdNumber === null || testIdNumber === '') {
		return "Enter valid identification number";
	}
	let testLength = testIdNumber.trim().length;
	if(testLength <= 0) {
		return "Enter valid identification number";
	}
	if(testLength > 32) {
		return "32 characters maximum";
	}
	return null;
}

export function streetValidation(testStreet) {
	if(testStreet === null) {
		return "Enter valid street";
	}
	let testLength = testStreet.trim().length;
	if(testLength <= 0) {
		return "Enter valid street";
	}
	if(testLength > 100) {
		return "100 characters maximum";
	}
	return null;
}

export function cityValidation(testCity) {
	if(testCity === null) {
		return "Enter valid city";
	}
	let testLength = testCity.trim().length;
	if(testLength <= 0) {
		return "Enter valid city";
	}
	if(testLength > 50) {
		return "100 characters maximum";
	}
	return null;
}

export function zipValidation(testZip) {
	if(!testZip) {
		return "Enter valid zip code";
	}
	let numberString = stringToDigits(testZip);
	if(numberString.length != 5 && numberString.length != 9) {
		return "Zip codes must either by 5 or 9 digits";
	}
	return null;
}

export function textValidation(testText) {
	if(testText === null) {
		return "Enter valid message";
	}
	let testLength = testText.trim().length;
	if(testLength <= 0) {
		return "Enter valid message";
	}
	return null;
}

export function fullDateValidation(dateString) {

  // First check for the pattern
  if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      return 'Enter a valid date (MM/DD/YYYY format)';

  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[1], 10);
  var month = parseInt(parts[0], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if(year < 1000 || year > 3000 || month == 0 || month > 12)
      return 'Enter a valid date (MM/DD/YYYY format)';

  var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  // Adjust for leap years
  if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1] ? null : 'Enter a valid date (MM/DD/YYYY format)';
};

export function dateValidation(dateString) {

  // First check for the pattern
  if(!/^\d{1,2}\/\d{1,2}$/.test(dateString))
      return 'Enter a valid date (MM/DD format)';

  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[1], 10);
  var month = parseInt(parts[0], 10);

  var monthLength = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1] ? null : 'Enter a valid date (MM/DD/YYYY format)';
};

export function selectValidation(selectValue) {
	if(selectValue === '') {
		return 'Please select a value';
	}
	return null;
}

export function amountValidation(testAmount, allowEmpty = false) {
	if(testAmount === '' && allowEmpty) {
		return null;
	}
	if(testAmount === '') {
		return "Please enter an amount";
	}
	if(!parseFloat(testAmount)) {
		return "Please enter a valid amount";
	}
	if(parseFloat(testAmount) <= 0) {
		return "Must be greater than zero";
	}
	return null;
}

















